/**
 * @Component 表单选项组件工厂
 * @Params { String } carrier 组件类型
 * @Params { Array } options 数据列表
 * @Return { VNode } el-radio el-radio-button el-checkbox el-option 4种
 */
export default {
  name: 'options',
  functional: true,
  render(createElement, context) {
    const { props: { carrier, options }, data } = context;

    if (carrier === 'radio') {
      return options.map(item => (
        <el-radio
          { ...data }
          key={ item.value }
          label={ item.value }
        >
          { item.label }
        </el-radio>
      ));
    }

    if (carrier === 'checkbox') {
      return options.map(item => (
        <el-checkbox
          { ...data }
          key={ item.value }
          label={ item.value }
        >
          { item.label }
        </el-checkbox>
      ));
    }

    if (carrier === 'radioButton') {
      return options.map(item => (
        <el-radio-button
          { ...data }
          key={ item.value }
          label={ item.value }
        >
          { item.label }
        </el-radio-button>
      ));
    }

    return options.map(item => (
      <el-option
        { ...data }
        key={ item.value }
        value={ item.value }
        label={ item.label }
      />
    ));
  },
};
